export class PersonalizationApi {
    constructor(http) {
        this.http = http;
    }
    getMyTopArtists(options) {
        return this.http.get('/me/top/artists', options && { params: options });
    }
    getMyTopTracks(options) {
        return this.http.get('/me/top/tracks', options && { params: options });
    }
}
